// Suppress the noisy "ResizeObserver loop completed with undelivered
// notifications" / "ResizeObserver loop limit exceeded" runtime errors
// that surface whenever a library using ResizeObserver (Radix popovers,
// Highcharts reflow, Floating UI, etc.) reacts to layout in the same
// frame the observer was scheduled. The browser breaks the loop on its
// own — the message is a harmless warning, not a real error — but the
// webpack-dev-server overlay treats it as a crash and pops up a red
// modal that hides the rest of the UI. Stopping propagation on the
// `error` event keeps the warning out of every downstream listener
// (overlay, Sentry, our own handlers) without muting genuine errors.
const RESIZE_OBSERVER_ERROR_PATTERN = /^ResizeObserver loop/;

window.addEventListener('error', event => {
    if (RESIZE_OBSERVER_ERROR_PATTERN.test(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
    }
});

// CSS
require('./css/wisemetering.css');
const {
    loadBaseModules,
    loadCollectionModules,
    loadFeatureViewModules,
    loadModelModules,
    loadServices,
    loadStartupModules,
    loadTemplateModules,
    loadUiModules
} = require('@/bootstrap/wisemetering');

const sync = Backbone.sync;
Backbone.sync = (method, model, opts) => sync(method === 'patch' ? 'update' : method, model, opts);

// Services
loadServices();

// Backbone react bridge navigation service
import { NavigationService } from './utils/navigation';
window.NavigationService = NavigationService;

// Load Font Awesome asynchronously so it is available to React icons without blocking startup.
void import('./icons');

// Base App
loadBaseModules();

// Models
loadModelModules();

// Collections
loadCollectionModules();

// Templates
loadTemplateModules();

// Views
loadUiModules();
loadFeatureViewModules();

// Start
loadStartupModules();
